import { Action } from '@ngrx/store';
import { Setting } from 'src/app/models/setting';

export enum SettingsActionTypes {
  Load = '[Settings] Load',
  LoadSuccess = '[Settings] Load Success',
  LoadFail = '[Settings] Load Fail',
  Reset = '[Settings] Reset'
}

export class Load implements Action {
  readonly type = SettingsActionTypes.Load;
}

export class LoadSuccess implements Action {
  readonly type = SettingsActionTypes.LoadSuccess;

  constructor(public payload: Setting[]) { }
}

export class LoadFail implements Action {
  readonly type = SettingsActionTypes.LoadFail;

  constructor(public payload: string) { }
}

export class Reset implements Action {
  readonly type = SettingsActionTypes.Reset;
}

export type SettingsActions = Load | LoadSuccess | LoadFail | Reset;
